import { request } from 'api/request';
import { services } from 'api/client';

const uploadService = services.uploadService;
const ADMIN_SUPPORT_MODULE_ID = 3;

export const uploadScriptFile = async ({ selectedFile, userId, scriptId }) => {
  const formData = new FormData();
  formData.append('file', selectedFile);

  const { data } = await request(uploadService, '/upload-file', {
    method: 'POST',
    searchParams: { uploaded_by: userId, selected_script_id: scriptId },
    body: formData,
  });

  return data.data ?? data;
};

export const fetchUploadHistory = async (userId) => {
  const { data } = await request(uploadService, '/get-all-files', {
    method: 'GET',
    searchParams: { uploader_user_id: userId, module_id: ADMIN_SUPPORT_MODULE_ID },
    headers: { 'Content-Type': 'application/json' },
  });

  return data.data ?? data;
};

export const fetchProcessedFile = async (fileId) => {
  const { data } = await request(uploadService, `/download-processed-file/${fileId}`, {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  });

  const result = data.data ?? data;
  return { signedUrl: result.signed_url ?? result.signedUrl };
};
